export default function PassVisualBox(props) {
  const lang = props.lang;

  return (
    <>

      <ul class="list01">
        <li>
          <div class="img-con01">
            <img src="/images/pass/m/pass_icon01.png " class="img" alt="" />
          </div>
          <div class="tit-wrap">
            <strong class="title01">
              {lang === 'en' ? (
                <>
                  Stream live with <em>no ads</em>
                </>
              ) : (
                <>
                  <em>광고 없는</em> 실시간 라이브
                </>
              )}
            </strong>
          </div>
          <div class="txt01">
            {lang === 'en' ? (
              <>
                <em>Crystal-clear HD</em><br />
                for your favorite SBS channels!
              </>
            ) : (
              <>
                <em>인기 SBS 채널을 초고화질</em>로,<br />생생하게
                즐겨보세요!
              </>
            )}
          </div>
        </li>
        <li>
          <div class="img-con01">
            <img src="/images/pass/m/pass_icon02.png " class="img" alt="" />
          </div>
          <div class="tit-wrap">
            <strong class="title01">
              {lang === 'en' ? (
                <>
                  <em>Unlimited</em> Replays
                </>
              ) : (
                <>
                  <em>무제한</em> 다시보기
                </>
              )}
            </strong>
          </div>
          <div class="txt01">
            {lang === 'en' ? (
              <>
                <em>100,000+ legendary shows,</em><br />whenever you want!
              </>
            ) : (
              <>
                <em>10만 편 레전드 콘텐츠,</em><br />언제든지 마음껏
                시청하세요!
              </>
            )}
          </div>
        </li>
        <li>
          <div class="img-con01">
            <img src="/images/pass/m/pass_icon03.png " class="img" alt="" />
          </div>
          <div class="tit-wrap">
            <strong class="title01">
              {lang === 'en' ? (
                <>
                  Live <em>Time Machine</em>
                </>
              ) : (
                <>
                  실시간 라이브 <em>타임머신</em>
                </>
              )}
            </strong>
          </div>
          <div class="txt01">
            {lang === 'en' ? (
              <>
                Don't worry about <em>2 hours ago,</em><br />
                You can look back!

              </>
            ) : (
              <>
                <em>최대 2시간 전까지,</em> 놓쳐도 걱정 마세요.<br />되돌아볼
                수 있어요!
              </>
            )}
          </div>
        </li>
      </ul>

    </>
  );
}